export default "__VITE_ASSET__woOhkY1v__"